import { ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import { EditorState } from "draft-js";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

class Helper {
  static isObjEquals = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };

  static isEmpty = (obj) => {
    if (obj === undefined) {
      return true;
    } else if (Helper.isObjEquals(obj, {})) {
      return true;
    } else if (Helper.isObjEquals(obj, [])) {
      return true;
    } else if (typeof obj == "string" && obj === "") {
      return true;
    }

    return false;
  };

  static EditorDraftToHTML(editorState) {
    var html = undefined;
    if (editorState) {
      html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      if (html === "<p></p>\n") {
        return undefined;
      }
    }
    return html;
  }

  static HTMLToEditorDraft(html = "") {
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  }
}

export default Helper;
